export default __webpack_public_path__ + "static/media/Password_Active.4d20b2b3.svg";